const KnobPlugin = {
    init: ($) => {
        $('[data-plugin="knob"]').each(() => $(this).knob());
    },
};

export default KnobPlugin;
